import { Box } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OrderActivityLogDrawer from "../../components/order-activity-log-drawer/OrderActivityLogDrawer";
import OrderPaymentOptions from "../../components/order-payment-options/OrderPaymentOptions";
import PaymentInfo from "../../components/payment-info/PaymentInfo";
import { PAYMENT_METHODS } from "../../constants/enums";
import { getCurrentOrderDetails } from "../../reduxStore/selectors/cartSelectors";
import {
  createKot,
  settleOrder,
  updateKot,
} from "../../reduxStore/slices/cartSlice";
import { incrementActiveCount } from "../../reduxStore/slices/tableSlice";
import { useNotify } from "../../utils/snackbarUtils";
import OrderActionTotal from "./OrderActionTotal";
import OrderActionsCounter from "./OrderActionsCounter";
import OrderActionsNonCounter from "./OrderActionsNonCounter";

function OrderActions({ itemTotal }) {
  const { user } = useSelector((state) => state.auth);
  const {
    customerDetails,
    orderType,
    activeOrderId,
    orderId,
    existingKots,
    orderInfo,
    selectedTable,
    pendingItems,
    note: itemsNote,
    loading: isLoading,
  } = useSelector((state) => state.cart);

  const orderDetails = useSelector(getCurrentOrderDetails);

  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const [isSettleDialogOpen, setIsSettleDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    PAYMENT_METHODS.CASH
  );
  const [openOrderActivityDrawer, setOpenOrderActivityDrawer] = useState(false);
  const open = Boolean(anchorEl);
  const storeId = user?.storeId;
  const isKOTValid = pendingItems.length > 0;
  const isSaveValid = pendingItems.length > 0;

  console.log("ddd", orderDetails);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDialogCancel = () => {
    setIsSettleDialogOpen(false);
  };

  const handleSettleClick = () => {
    setIsSettleDialogOpen(true);
  };

  // Reusable KOT submit function (build + dispatch)
  const submitKot = async (extraOptions = {}) => {
    try {
      // Build items array
      const items = pendingItems.map((item) => ({
        variant_uid: item.variant_uid,
        quantity: item.quantity,
        price: item.current_price?.final_price,
        comment: item.note,
        addons: item.selectedAddons || [],
        pricing_uid: item.current_price?.pricing_uid,
        tax_rule_uid: item.tax_rule?.tax_rule_uid,
        is_new_record: 1,
      }));

      // Base payload
      const payload = {
        store_id: storeId,
        order_type_id: orderType.type,
        customer_uid: customerDetails?.uid,
        total_amount: itemTotal,
        items,
        comment: itemsNote,
        dine_area_table_uid: selectedTable?.table?.dine_area_table_uid,
        ...extraOptions, // Add custom flags (print, hold, kot, etc.)
      };

      // Add order IDs only when updating
      if (activeOrderId) {
        payload.order_uid = activeOrderId;
        payload.order_id = orderId;
      }

      // Dispatch
      let res;
      if (activeOrderId) {
        res = await dispatch(updateKot(payload)).unwrap();
      } else {
        res = await dispatch(createKot(payload)).unwrap();
        if (payload?.dine_area_table_uid) {
          dispatch(incrementActiveCount());
        }
      }

      return res;
    } catch (err) {
      throw err;
    }
  };

  const handleKOTClick = async () => {
    try {
      await submitKot({ is_kot_order: 1 });
      showSuccess("KOT added successfully");
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleKOTPrintClick = async () => {
    try {
      await submitKot({ is_kot_order: 1 });
      showSuccess("KOT printed successfully");
    } catch (err) {
      handleApiError(err);
    }
  };
  const handleHoldClick = async () => {
    try {
      await submitKot({ is_kot_order: 0 });
      showSuccess("Order held successfully");
    } catch (err) {
      handleApiError(err);
    }
  };
  const handlePrintClick = async () => {};

  const handleCounterSettleClick = async () => {
    try {
      console.log("selectedPaymentMethod", selectedPaymentMethod);
      const kotResult = await submitKot({ is_kot_order: 1 });
      console.log("kotResult", kotResult);
      const obj = {
        store_id: storeId,
        order_id: kotResult?.order_id,
        order_uid: kotResult?.order_uid,
        order_status_id: 5,
        payment_options: [
          {
            payment_option_id: selectedPaymentMethod?.value,
            total_amount: 500,
          },
        ],
        total_amount: 1000,
        amount_received: 950,
        settleFromCounter: true,
      };

      const res = await dispatch(settleOrder(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleActivityClick = () => {
    setOpenOrderActivityDrawer(true);
  };

  return (
    <>
      <Box className="menu-item-bill-bottom">
        {orderType.type !== 5 && (
          <>
            <OrderActionTotal itemTotal={itemTotal} />
            <OrderActionsNonCounter
              isSaveValid={isSaveValid}
              onKOTClick={handleKOTClick}
              onKOTPrintClick={handleKOTPrintClick}
              onHoldClick={handleHoldClick}
              onPrintClick={handlePrintClick}
              isKOTValid={isKOTValid}
              onSettleClick={handleSettleClick}
              onOpenMenu={handleOpenMenu}
              onCloseMenu={handleCloseMenu}
              anchorEl={anchorEl}
              open={open}
              activeOrderId={activeOrderId}
              isLoading={isLoading}
              onActivityClick={handleActivityClick}
            />
          </>
        )}
        {orderType.type === 5 && (
          <Box>
            <Box>
              <OrderActionTotal itemTotal={itemTotal} />
            </Box>
            <Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  gap: "5px",
                }}
              >
                <OrderPaymentOptions
                  actionType={"COUNTER"}
                  selectedPaymentMethod={selectedPaymentMethod}
                  setSelectedPaymentMethod={setSelectedPaymentMethod}
                />
                <OrderActionsCounter
                  onOpenMenu={handleOpenMenu}
                  onCloseMenu={handleCloseMenu}
                  anchorEl={anchorEl}
                  open={open}
                  activeOrderId={activeOrderId}
                  onCounterSettle={handleCounterSettleClick}
                  isLoading={isLoading}
                  onActivityClick={handleActivityClick}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      {isSettleDialogOpen && (
        <PaymentInfo
          isSettleDialogOpen={isSettleDialogOpen}
          onDialogCancel={handleDialogCancel}
          orderDetails={orderDetails}
        />
      )}
      {openOrderActivityDrawer && (
        <OrderActivityLogDrawer
          openOrderActivityDrawer={openOrderActivityDrawer}
          setOpenOrderActivityDrawer={setOpenOrderActivityDrawer}
        />
      )}
    </>
  );
}

export default OrderActions;
